import { createSlice } from "@reduxjs/toolkit";

// const INIT_STATE: {
//   data: LP;
//   skillExpertsData: [LPSkillExpert];
//   learnerCount: number;
//   lpSkillsData: any;
//   preview: boolean;
//   action: boolean;
// } = {
//   data: {} as LP,
//   skillExpertsData: [{} as LPSkillExpert] as [LPSkillExpert],
//   learnerCount: 0,
//   lpSkillsData: [] as any,
//   preview: false,
//   action: true,
// };

interface AssessmentInviteCriteria {
  assessmentId: string;
  messageCode: string;
  successList: any[];
  failureList: any[];
  failureModifiedList: any[];
}

const INIT_STATE = {
  data: {},
  selectedQp: null,
  scheduleData: {},
  timer: false,
  scheduleTimer: false,
  isPreview: false,
  assessmentInviteList: [] as AssessmentInviteCriteria[]
};

const AssessmentAuthSlice = createSlice({
  name: "AssessmentAuthSlice",
  initialState: INIT_STATE,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setSelectedQp(state, action) {
      state.selectedQp = action.payload;
    },
    setScheduleData(state, action) {
      state.scheduleData = action.payload;
    },
    setTimer(state, action) {
      state.timer = action.payload;
    },
    setScheduleTimer(state, action) {
      state.scheduleTimer = action.payload;
    },
    setPreview(state, action) {
      state.isPreview = action.payload;
    },
    setAssessmentInviteList(state, action) {
      state.assessmentInviteList = action.payload;
    },
    setResetState() {
      return INIT_STATE;
    }
  }
});

export default AssessmentAuthSlice;

export const AssessmentAuthSliceActions = AssessmentAuthSlice.actions;
